import React, { useState } from "react";
import { MdOutlineNavigateNext } from "react-icons/md";
import RepairInquiriesCard from "./RepairInquiriesCard";

const RepairInquiriesData = ({ onCardSelect }) => {

  const [showMore, setShowMore] = useState(false);

  const cardData = [
    {
      title: "Credit Repair Service",

      desc: "ALLIANCE ONE",
      icons: <MdOutlineNavigateNext />,
      status: "TransUnion",
    },
    // Repeat for all 9 cards
    {
      title: "Credit Repair Service",

      desc: "ALLIANCE ONE",
      icons: <MdOutlineNavigateNext />,
      status: "TransUnion",
    },
    {
      title: "Credit Repair Service",

      desc: "ALLIANCE ONE",
      icons: <MdOutlineNavigateNext />,
      status: "TransUnion",
    },
    {
      title: "Credit Repair Service",

      desc: "ALLIANCE ONE",
      icons: <MdOutlineNavigateNext />,
      status: "TransUnion",
    },
    {
      title: "Credit Repair Service",

      desc: "ALLIANCE ONE",
      icons: <MdOutlineNavigateNext />,
      status: "TransUnion",
    },
    {
      title: "Credit Repair Service",

      desc: "ALLIANCE ONE",
      icons: <MdOutlineNavigateNext />,
      status: "TransUnion",
    },
    {
      title: "Credit Repair Service",

      desc: "ALLIANCE ONE",
      icons: <MdOutlineNavigateNext />,
      status: "TransUnion",
    },
    {
      title: "Credit Repair Service",

      desc: "ALLIANCE ONE",
      icons: <MdOutlineNavigateNext />,
      status: "TransUnion",
    },
    {
      title: "Credit Repair Service",

      desc: "ALLIANCE ONE",
      icons: <MdOutlineNavigateNext />,
      status: "TransUnion",
    },
  ];

  const defaultCards = cardData.slice(0, 3);
  const extraCards = cardData.slice(3);

  return (
    <div className="row">
      {defaultCards.map((card, index) => (
        <div className="col-lg-4 col-md-6 col-sm-12" key={index}>
          <RepairInquiriesCard
            title={card.title}
            btn_text={card.btn_text}
            desc={card.desc}
            icons={card.icons}
            status={card.status}
            onCardSelect={onCardSelect}
          />
        </div>
      ))}

      {/* Show more cards if "View More" is clicked */}
      {showMore &&
        extraCards.map((card, index) => (
          <div className="col-lg-4 col-md-6 col-sm-12" key={index + 6}>
            <RepairInquiriesCard
              title={card.title}
              btn_text={card.btn_text}
              desc={card.desc}
              icons={card.icons}
              status={card.status}
              onCardSelect={onCardSelect}
            />
          </div>
        ))}

      {/* Button to toggle "View More" */}
      <div className="view_btn mt-4">
        <button className="btn btn_s" onClick={() => setShowMore(!showMore)}>
          {showMore ? "View Less" : "View More"}
        </button>
      </div>
    </div>
  );
};

export default RepairInquiriesData;
